import * as types from './actionTypes';
import client from 'helpers/client';
import cognito from 'helpers/cognito';
import store from 'redux/store';

export const getKarma = (email) => {
  return async (dispatch) => {
    dispatch({ type: types.GET_KARMA });

    client
      .api(`/karma/get-karma?email=${email}`, 'get', { headers: await cognito.getHeaderAuthorization() })
      .then((res) => {
        dispatch({
          type: types.GET_KARMA_SUCCESS,
          data: res.data.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: types.GET_KARMA_FAILED,
          reason: err,
        });
      });
  };
};

export const getKarmaHistory = (limit, page) => {
  return async (dispatch) => {
    const karma = store.getState().karma;
    const { history, pagination } = karma;
    if (pagination.page === page) return;
    dispatch({ type: types.GET_KARMA_HISTORY });

    client
      .api(`/karma/get-karma-history?limit=${limit}&page=${page}`, 'get', {
        headers: await cognito.getHeaderAuthorization(),
      })
      .then(({ data }) => {
        dispatch({
          type: types.GET_KARMA_HISTORY_SUCCESS,
          data: {
            history: [...history, ...data.data],
            pagination: data.pagination,
          },
        });
      })
      .catch((err) => {
        dispatch({
          type: types.GET_KARMA_HISTORY_FAILED,
          reason: err,
        });
      });
  };
};
